import { MenuItem } from "@mui/material";

export const emptyMenuItem = (value: string | number) => (
  <MenuItem value={value}>- None -</MenuItem>
);
